<template>
  <PCHeaderBar />
  
  <div class="pc__flash-sales">
    <div class="pc__flash-sales-inner">
      <PCBreadcrumbs
        :breadcrumbs="[
          { id: '/', name: 'Home', path: '/' },
          { id: '/flash-sales', name: 'Flash Sales' }
        ]"
        :breadcrumbs:click="(e: IBreadcrumbs) => e.path && $router.push(e.path)"
      />

      <!-- <div class="header-title">
        <img v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/flashsales_header_text.png')" alt="">
      </div> -->
      <div class="pc__flash-sales-headers">
        <!-- flash-sales-bg@2x.png -->
        <h1 class="title-text">Kilimall Flash Sales</h1>
        <!-- <p class="title-text">Kilimall Flash Sales</p> -->
      </div>

      <div class="tabs" id="pc__flash-sales__tabs" @wheel="e => handleCategoryScroll(e, 'tabs')">
        <div class="tab-item">
          <span class="time-label">
            <span class="cd-time">{{ countdown.h }}</span>
            <span class="cd-split">:</span>
            <span class="cd-time">{{ countdown.m }}</span>
            <span class="cd-split">:</span>
            <span class="cd-time">{{ countdown.s }}</span>
          </span>
          <span class="status-label" v-if="actStatus === 1">Closing in</span>
          <span class="status-label" v-else-if="actStatus === 4">Over</span>
          <span class="status-label" v-else>Starting in</span>
          <!-- ="actStatus !== 1" -->
        </div>
        <div
          v-for="(item, idx) in flashSalesTime"
          :key="idx"
          :id="`pc__flash-sale-tab__${item.id}`"
          :class="item.act ? 'tab-item tab-item-act' : 'tab-item'"
          @click="handleTimeSwitchClick(item)"
        >
          <p class="time-label">{{ item.label }}</p>
          <p class="status-label">
            {{ useFlashSalesStatusMap().value[item.status] }}
          </p>
        </div>
      </div>

      <div class="sku-categorys" v-if="categoryList.length > 0" @wheel="e => handleCategoryScroll(e, 'sku-categorys')">
        <div
          v-for="item in categoryList"
          :key="item.id"
          :class="selectCategoryId === item.id 
            ? 'category-item act-category-item'
            : 'category-item'
          "
          @click="handleCategoryClick(item.id)"
        >
          {{ item.name  }}
        </div>
      </div>

      <div class="skus">
        <div
          v-for="sku in skus"
          :key="sku.skuId"
          class="sku-item"
        >
          <PCProductItemCard
            type="flash-sale"
            :product-data="sku"
            :status="actStatus"
            :flash-sale-session-label="flashSaleSessionLabel"
            :flash-sale-category-name="flashSaleCategoryName"
          />
        </div>

        <PCEmpty v-if="skus.length <= 0" title-text="There are no active products." />
      </div>

      <div class="load-more" @click="handleLoadMoreClick" v-if="!finished">
        <span class="loading" v-show="loading">
          <van-loading size="20px" color="#DD3131" type="spinner" />
        </span>
        <span>SHOW MORE</span>
      </div>
    </div>
  </div>

  <PCFooter />
</template>

<script setup lang="ts">
import type { ICountdown, IFSTime, ICategory } from '@/pages/flash-sales.vue'
import type { IBreadcrumbs } from '~/components/PC/Breadcrumbs.vue';
interface IProps {
  flashSalesTime: IFSTime[]
  countdown: ICountdown
  categoryList: ICategory[]
  selectCategoryId: number
  skus: any[]
  loading: boolean
  finished: boolean
  actStatus: number
  flashSaleSessionLabel?: string
  flashSaleCategoryName?: string
}
interface IEmits {
  (event: 'time:click', e: IFSTime): void
  (event: 'load:more'): void
  (event: 'category:click', e: number): void
}
const props = defineProps<IProps>()

const emits = defineEmits<IEmits>()

watchEffect(
  async() => {
    const actItem = props.flashSalesTime.find((c: IFSTime) => c.act)

    if(actItem) {
      await nextTick()
      const el = document.getElementById(`pc__flash-sale-tab__${actItem.id}`) as HTMLDivElement
      const tabsEl = document.getElementById('pc__flash-sales__tabs') as HTMLDivElement
 
      if(tabsEl && el) {
        const width21 = el.clientWidth
        const tabsW = tabsEl.clientWidth / 2
        
        tabsEl.scrollLeft = el.offsetLeft - tabsW - (width21 / 2) * 3 
      }
    }
  }
)

const handleTimeSwitchClick = (item: IFSTime) => {
  emits('time:click', item)
}

const handleLoadMoreClick = () => {
  emits('load:more')
}

const handleCategoryClick = (e: number) => {
  emits('category:click', e)
}

const handleCategoryScroll = (e: WheelEvent, className: string) => {
  e.preventDefault()

  const val = e.deltaY / 2
  const ctgEl = document.getElementsByClassName(className)[0]
  ctgEl.scrollLeft += val
}
</script>

<style lang="scss" scoped>
.conditions{
  background-color: #fff;
  padding: 60px 40px;
  margin-top: 40px;
  .tips-title{
    color: var(--pc-default-color);
    font-weight: 600;
    font-size: 46px;
    margin-bottom: 30px;
    text-align: center;
  }
  .tips{
    color: #666;
    line-height: 60px;
  }
  border: 4px solid var(--pc-default-color);
}
.pc__flash-sales-inner{
  width: var(--viewport-width);
  margin: 0 auto;
  padding-bottom: 80px;
}

.pc__flash-sales-headers{
  text-align: center;
  font-size: 80px;
  text-shadow: 0 0 2px var(--default_color);
  color: var(--default_color);
  height: 296px;
  line-height: 296px;
  background: linear-gradient(90deg, #FED5D1 0%, #FFF5F4 100%);
  position: relative;
  margin-bottom: 30px;
  .title-text{font-weight: 600;}
  &::after{
    content: " ";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 636px;
    background-image: url('https://img.kilimall.com/c/h5/imgs/flash-sales-bg@2x.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

.tabs{
  $h: 240px;

  display: flex;
  overflow: auto hidden;
  // border-bottom: 1px solid #efefef;
  background: linear-gradient(90deg, #FF3400 0%, #FF6500 100%);
  height: $h;
  &::-webkit-scrollbar{
    display: none;
  }
  .tab-item{
    flex: 1;
    text-align: center;
    transition: all .15s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: $h;
    white-space: nowrap;
    padding: 0 80px;
    color: #fff;
    .time-label{
      font-size: 64px;
      font-weight: 600;
    }
    .status-label{
      color: #fff;
      border: 1px solid #fff;
      padding: 12px 30px;
      margin-top: 10px;
      font-size: 26px;
      border-radius: 60px;
    }
    &:first-child{
      background-color: #fff;
      color: #150000;
      $th: 72px;
      .cd-time{
        font-size: 48px;
        background-color: #150000;
        color: #fff;
        display: inline-block;
        height: $th;
        line-height: $th;
        width: $th;
        border-radius: 8px;
      }
      .cd-split{
        margin: 0 6px;
        display: inline-block;
      }
      .status-label{
        color: var(--default_color);
        border-color: var(--default_color);
      }
    }
  }
  .tab-item-act {
    background-color: #fff;
    
    .time-label, .status-label{
      color: var(--default_color);
      border-color: var(--default_color);
      font-weight: 600;
    }
  }
}

.sku-categorys{
  display: flex;
  width: 100%;
  background-color: #fff;
  padding: 40px 30px;
  overflow-x: auto;
  position: relative;
  &::-webkit-scrollbar{
    display: none;
  }

  .category-item{
    margin-right: 20px;
    white-space: nowrap;
    padding: 16px 30px;
    background-color: #efefef;
    color: #999;
    cursor: pointer;
    border-radius: 6px;
    &:last-child{
      margin-right: 0;
    }
  }
  .act-category-item{
    background-color: var(--default_color);
    color: #fff;
  }
}
.skus{
  display: flex;
  margin: 0 -20px;
  flex-wrap: wrap;
  .sku-item{
    width: 25%;
    padding: 20px;
  }
}

.load-more{
  margin: 80px auto;
  border: 2px solid #efefef;
  box-shadow: 0 0 4px #666;
  text-align: center;
  cursor: pointer;
  height: 80px;
  @include center();
  width: 600px;
  color: #666;
  font-weight: 800;
  // position: relative;
  .loading{
    margin-right: 16px;
  }
}
</style>